import styled from 'styled-components'

export const HeaderUnderScore = styled.hr`
  width: 60%;
`

export const Container = styled.div`
  padding:10%;
`;

export const CenterAlignedHeading = styled.h3`
   text-align:center;
   margin-bottom:1em;
`



// WEBPACK FOOTER //
// ./src/Common/Common.style.js